<template>
  <div class="content mb-5">
    <t-sub-nav :items="tabNavItems" class="mb-5" />

    <b-row class="mb-6">
      <b-col sm="12" md="6" lg="6">
        <b-form-group
          v-if="!loading"
          class="mb-3"
          label-for="name"
          :label="this.$t('Lookup URL / FQDN')"
          :state="$validateState($v.form.domain)"
        >
          <b-form-input
            id="domain"
            data-test-id="recategorize-domain-domain"
            @blur="setValidationInput('domain', $event.target.value)"
            :state="$validateState($v.form.domain)"
            :placeholder="this.$t('Enter URL / FQDN')"
          />

          <template #invalid-feedback>
            <p v-if="!$v.form.domain.maxLength">
              {{ $t("Must contain at most 200 characters.") }}
            </p>
          </template>
        </b-form-group>
        <b-skeleton
          v-if="loading"
          animation="wave"
          height="32px"
          width="100%"
        ></b-skeleton>
      </b-col>
      <b-col sm="12" md="6" lg="6">
        <b-form-group
          v-if="!loading"
          id="category1"
          :label="this.$t('Category X', { categoryNumber: 1 })"
          label-for="category1"
        >
          <b-form-select
            data-test-id="recategorize-domain-category-one"
            v-model="$v.form.category1.$model"
            :options="categoryOptions"
          ></b-form-select>
        </b-form-group>

        <b-form-group
          v-if="!loading"
          id="category2"
          :label="this.$t('Category X', { categoryNumber: 2 })"
          label-for="category2"
        >
          <b-form-select
            data-test-id="recategorize-domain-category-two"
            v-model="$v.form.category2.$model"
            :options="categoryOptions"
          ></b-form-select>
        </b-form-group>

        <b-form-group
          v-if="!loading"
          id="category3"
          :label="this.$t('Category X', { categoryNumber: 3 })"
          label-for="category3"
        >
          <b-form-select
            data-test-id="recategorize-domain-category-three"
            v-model="$v.form.category3.$model"
            :options="categoryOptions"
          ></b-form-select>
        </b-form-group>

        <b-skeleton
          v-if="loading"
          animation="wave"
          height="32px"
          width="30%"
        ></b-skeleton>
        <b-skeleton
          v-if="loading"
          class="mb-5"
          animation="wave"
          height="32px"
          width="100%"
        ></b-skeleton>
        <b-skeleton
          v-if="loading"
          animation="wave"
          height="32px"
          width="30%"
        ></b-skeleton>
        <b-skeleton
          v-if="loading"
          class="mb-5"
          animation="wave"
          height="32px"
          width="100%"
        ></b-skeleton>
        <b-skeleton
          v-if="loading"
          animation="wave"
          height="32px"
          width="30%"
        ></b-skeleton>
        <b-skeleton
          v-if="loading"
          class="mb-5"
          animation="wave"
          height="32px"
          width="100%"
        ></b-skeleton>
      </b-col>
    </b-row>

    <t-save-button
      data-test-id="recategorize-domain-save"
      btn-text="Submit"
      :form-model="$v.form"
      :fetching="fetching"
      @submit="onSubmit"
    />
  </div>
</template>

<route>
{
  "name": "MSP Global Recategorize Domain"
}
</route>

<script>
import { mapActions, mapGetters } from "vuex";
import { required, maxLength } from "vuelidate/lib/validators";

export default {
  layout: "msp",
  methods: {
    ...mapActions("pageMeta", ["setPageTitle", "setPageSubtitle"]),
    ...mapActions("defaultPolicy", [
      "fetchDefaultPolicyCategories",
      "updateRegategorizeDomains",
    ]),
    ...mapActions("toast", ["displayToast"]),
    setValidationInput(object, value) {
      this.form[`${object}`] = value;
      this.$v.form[`${object}`].$touch();
    },
    async onSubmit() {
      this.fetching = true;
      try {
        await this.updateRegategorizeDomains({ body: this.form });
        this.displayToast({
          title: this.$t("Success"),
          message: this.$t("Updated"),
          duration: 2000,
          variant: "success",
        });
      } finally {
        this.fetching = false;
        this.$v.form.$reset();
      }
    },
  },
  computed: {
    ...mapGetters("authentication", ["selectedUser", "mspId"]),
    ...mapGetters("defaultPolicy", ["defaultCategories"]),
  },
  data: function () {
    return {
      loading: true,
      fetching: false,
      categoryOptions: [],
      form: {
        domain: null,
        category1: null,
        category2: null,
        category3: null,
      },
      tabNavItems: this.$secondaryNav.toolsNavItems.msp(),
    };
  },
  validations: {
    form: {
      domain: {
        required,
        maxLength: maxLength(200),
      },
      category1: {},
      category2: {},
      category3: {},
    },
  },
  wait: {
    defaultCategories() {
      this.categoryOptions = [
        {
          value: null,
          text: this.$t("Please select an option"),
          disabled: true,
        },
        ...this.defaultCategories.map((p) => {
          return { value: p.id, text: p.name };
        }),
      ];
    },
  },
  async created() {
    this.setPageTitle(this.$t("Tools"));
    try {
      await this.fetchDefaultPolicyCategories({ mspId: this.mspId });
      this.categoryOptions = [
        {
          value: null,
          text: this.$t("Please select an option"),
          disabled: true,
        },
        ...this.defaultCategories.map((p) => {
          return { value: p.id, text: p.name };
        }),
      ];
    } finally {
      this.loading = false;
    }
  },
  mounted() {
    this.setPageSubtitle([
      this.$t(
        "The diagnostic tools allow you to test filtering, to evaluate domains and to recategorize domains."
      ),
    ]);
  },
};
</script>
